module.exports = __webpack_public_path__ + "st-barts.svg?0b8158f1c5f8e78df7454f06136a1a3d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/st-barts.svg
// module id = 304
// module chunks = 10